import { Button, Result, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useResendVerificationEmail } from '@presentation/hooks/useAuth';
import { useAuthStore } from '@presentation/stores/authStore';

export const VerifyEmailNoticePage = () => {
  const user = useAuthStore((state) => state.user);
  const resend = useResendVerificationEmail();

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Result
        icon={<MailOutlined />}
        title="Verify your email"
        subTitle={
          <>
            We sent a verification link to <Typography.Text strong>{user?.email}</Typography.Text>.
            Click it to confirm your address.
          </>
        }
        extra={
          <div className="flex flex-col items-center gap-2">
            <Button type="primary" onClick={() => resend.mutate()} loading={resend.isPending}>
              Resend verification email
            </Button>
            {resend.isSuccess && (
              <Typography.Text type="success">Verification link sent.</Typography.Text>
            )}
          </div>
        }
      />
    </div>
  );
};
